/**
 * @description
 * Select product variant based on provided product options
 */ export const selectVariantReducer = function(state, action) {
    const { optionsWithValues , variants , selectedVariantId: prevSelectedVariantId  } = state;
    if (variants.length === 0) {
        return state;
    }
    const prevSelectedVariant = variants.find(function(v) {
        return v.id === prevSelectedVariantId;
    }) || null;
    if (prevSelectedVariant === null) {
        return state;
    }
    const { payload: { optionValue: triggerOptionValue , optionIndex: rawTriggerOptionIndex  }  } = action;
    const triggerOptionIndex = Math.round(rawTriggerOptionIndex);
    const nextOptions = prevSelectedVariant.options.map(function(originalOption, originalOptionIndex) {
        return originalOptionIndex === triggerOptionIndex ? triggerOptionValue : originalOption;
    });
    const calculateCandidateWeight = function(variant) {
        const weight = variant.options.reduce(function(acc, optionValue, optionIndex) {
            const optionPositionBonus = 1000 - optionIndex * 500;
            const nextOptionValue = nextOptions[optionIndex];
            const optionMatch = optionValue === nextOptionValue ? 100 + optionPositionBonus : 0;
            const triggerOptionMatch = optionValue === triggerOptionValue && optionIndex === triggerOptionIndex ? 100 : 0;
            const optionWithValues = optionsWithValues[optionIndex];
            if (optionWithValues == null) {
                throw new Error('Option with values not found by index [c9b74da1a44a4766a923ad4577c712d9]');
            }
            const allOptionValues = optionWithValues.values;
            const optionPosition = allOptionValues.findIndex(function(v) {
                return v === optionValue;
            });
            const nextOptionPosition = allOptionValues.findIndex(function(v) {
                return v === nextOptionValue;
            });
            const proximity = Math.abs(optionPosition - nextOptionPosition);
            const proximityMatch = allOptionValues.length === 0 ? 0 : proximity === 0 ? 250 : proximity <= 1 ? 200 : proximity <= 3 ? 150 : proximity <= 5 ? 100 : 0;
            const adjustedProximityMatch = proximityMatch - optionIndex * 10;
            return acc + optionMatch + triggerOptionMatch + adjustedProximityMatch;
        }, 0);
        return weight * -1;
    };
    const candidates = [
        ...variants
    ].sort(function(a, b) {
        return calculateCandidateWeight(a) - calculateCandidateWeight(b);
    });
    // console.log('-----', nextOptions)
    // candidates.forEach((v) => {
    //   console.log(nextOptions, v.options, calculateCandidateWeight(v))
    // })
    const selectedVariant = candidates[0];
    if (selectedVariant == null) {
        return state;
    }
    const selectedVariantId = selectedVariant.id;
    const selectedOptionIndex = selectedVariant.options[triggerOptionIndex] != null ? triggerOptionIndex : 0;
    const selectedOptionValue = selectedVariant.options[selectedOptionIndex];
    if (selectedOptionValue == null) {
        return state;
    }
    return {
        optionsWithValues,
        variants,
        selectedVariantId,
        selectedOptionIndex,
        selectedOptionValue
    };
};
